import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StatisticsState } from './statistics.reducer';

const selectState = createFeatureSelector<StatisticsState>('statistics');

export const selectSaleFullViewingLog = createSelector(
  selectState,
  (state: StatisticsState) => {
    return state.saleFullViewingLogStatistcs;
  }
);

export const selectSaleFullViewingLogLoaded = createSelector(
  selectState,
  (state: StatisticsState) => state.SaleFullViewingLogStatistcsLoaded
);

export const saleViewingSummary = createSelector(
  selectState,
  (state: StatisticsState) => {
    return state.saleViewingSummary;
  }
);

export const saleViewingSummaryLoaded = createSelector(
  selectState,
  (state: StatisticsState) => state.saleViewingSummaryLoaded
);

export const selectStatError = createSelector(selectState, (state) => state.error);
export const selectConsignorSale = createSelector(selectState, (state) => state.consignorSale);
export const selectConsignorSaleLoaded = createSelector(selectState, (state) => state.consignorSaleLoaded);
export const selectMarkAsArchived = createSelector(selectState, (state) => state.markAsArchived);
